<template>
  <div class="pathMan">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['系统配置', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('')"
          >添加</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">类型：</label>
        <el-select
          v-model="searchForm.type"
          placeholder="类型"
          style="width: 100px; margin-right: 5px"
          @change="getTableData"
        >
          <el-option label="商城后台" value="B2B"></el-option>
          <el-option label="业务通" value="YWT"></el-option>
        </el-select>
        <label class="label">是否启用：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="是否启用"
          style="width: 100px; margin-right: 5px"
          clearable
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="已启用" value="2"></el-option>
          <el-option label="未启用" value="1"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 90px)"
      tooltip-effect="dark"
      :row-style="{ color: '#303133' }"
      :row-key="getRowKeys"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" type="index" width="70">
      </el-table-column>
      <el-table-column type="expand" label="展开" align="center" width="50">
        <template slot-scope="props">
          <el-table
            :data="props.row.childs"
            stripe
            border
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column label="序号" align="center" width="70">
              <template slot-scope="scope">
                <span>{{ props.$index + 1 }}-{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="name"
              show-overflow-tooltip
              label="名称"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="buttons"
              show-overflow-tooltip
              label="按钮名称"
            >
            </el-table-column>
            <el-table-column
              prop="path"
              align="center"
              show-overflow-tooltip
              label="路径"
            >
            </el-table-column>
            <el-table-column
              prop="sort"
              label="排序"
              align="center"
              width="100"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="status"
              label="是否启用"
              align="center"
              width="100"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-tag :type="scope.row.status | formatType">{{
                  scope.row.status | formatStatus
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="warning"
                  style="padding: 2px 3px"
                  plain
                  v-if="scope.row.status == 1"
                  @click="changeStatus(scope.row, 0)"
                  >禁用</el-button
                >
                <el-button
                  type="success"
                  style="padding: 2px 3px"
                  plain
                  v-else
                  @click="changeStatus(scope.row, 1)"
                  >启用</el-button
                >
                <el-button
                  type="primary"
                  style="padding: 2px 3px"
                  plain
                  @click="handleAdd(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="danger"
                  style="padding: 2px 3px"
                  plain
                  @click="changeStatus(scope.row, 2)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        show-overflow-tooltip
        label="名称"
      >
      </el-table-column>
      <el-table-column
        prop="path"
        align="center"
        show-overflow-tooltip
        label="路径"
      >
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        align="center"
        width="100"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="是否启用"
        align="center"
        width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | formatType">{{
            scope.row.status | formatStatus
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            v-if="scope.row.status == 1"
            @click="changeStatus(scope.row, 0)"
            >禁用</el-button
          >
          <el-button
            type="success"
            style="padding: 2px 3px"
            plain
            v-else
            @click="changeStatus(scope.row, 1)"
            >启用</el-button
          >
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 2)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加 -->
    <el-drawer
      title=""
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">功能管理</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="80px"
            :rules="formRule"
            ref="addForm"
          >
            <el-form-item label="权限名称" prop="name">
              <el-input v-model="addForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="路径地址" prop="path">
              <el-input v-model="addForm.path" clearable></el-input>
            </el-form-item>
            <el-form-item label="父级" prop="parentId">
              <el-select
                filterable
                v-model="addForm.parentId"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="一级路径" :value="0"></el-option>
                <el-option
                  v-for="(item, index) in tableData"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="按钮名称" prop="button">
              <el-input v-model="addForm.buttons" clearable></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input-number
                v-model="addForm.sort"
                :min="0"
                style="width: 100%; text-align: left"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="图标" prop="icon">
              <el-input v-model="addForm.icon" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submitForm">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//混入
import { mustFill } from "@/mixins/data/valid.js"; //混入表单必填项

export default {
  name: "pathMan",
  data() {
    return {
      adminId: this.$store.state.userInfo.adminId,
      organId: this.$store.state.userInfo.organId,
      //Id	权限名称	路径名称	父级Id	排序	是否启用 类型b2b/app	操作
      tableData: [
        {
          id: "Id",
          name: "权限名称",
          path: "路径名称",
          parentId: "父级Id",
          sort: "排序",
          status: "是否启用",
          type: "类型b2b/app",
        },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 1000,
      allPage: 0,
      /**新增drawer */
      addDrawer: false,
      /**新增表单 */
      //分类 权限名称 路径地址 父级 排序
      addForm: {
        id: "",
        type: "",
        name: "",
        path: "",
        parentId: "",
        sort: "",
        icon: "",
        buttons: ""
      },
      /**表单规则 */
      formRule: {
        type: [mustFill],
        name: [mustFill],
        path: [mustFill],
        parentId: [mustFill],
        sort: [mustFill],
      },
      /**搜索表单 */
      searchForm: {
        status: "99",
        type: "B2B",
        name: "",
      },
      /**select选中项 */
      selectedList: [],
    };
  },
  mounted() {
    this.getTableData();
  },
  filters: {
    /**转换tips状态 */
    formatType(num) {
      if (num == 1) {
        return "success";
      } else {
        return "danger";
      }
    },
    /**转换状态码 */
    formatStatus(num) {
      if (num == 1) {
        return "启用中";
      } else {
        return "已禁用";
      }
    },
  },
  methods: {
    /**获取表格 */
    getTableData() {
      this.$request({
        url: "Role/PowerList",
        method: "post",
        data: {
          status: this.searchForm.status || "99",
          source: this.searchForm.type,
          strWhere: this.searchForm.name,
          pageIndex: this.currPage,
          pageSize: this.pageSize,
        },
      })
        .then((res) => {
          console.log('获取表格',res);
          this.allPage = res.Total;
          this.tableData = [];
          if (res.Code) {
            //一级菜单而二级菜单都加到一起
            /**递归函数 */
            this.tableData = this.recursion(res.Obj);
            console.log('递归',this.tableData);
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**数据处理函数 */
    recursion(list) {
      let obj = {};
      for (let i = 0; i < list.length; i++) {
        if (!obj[list[i].FatherId || 0]) {
          obj[list[i].FatherId || 0] = [];
        }
        obj[list[i].FatherId || 0].push({
          id: list[i].Id,
          name: list[i].Title,
          path: list[i].Power,
          parentId: list[i].FatherId,
          sort: list[i].Sort,
          status: list[i].Status,
          type: list[i].Source,
          icon: list[i].IcoAddress,
          childs: [],
          buttons: list[i].Buttons || '', 
        });
      }
      for (let i = 0; i < obj[0].length; i++) {
        obj[0][i].childs = obj[obj[0][i].id];
      }
      return obj[0];
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },

    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**新增路径 */
    handleAdd(row) {
      this.clearForm();
      if (row) {
        for (const key in this.addForm) {
          this.addForm[key] = row[key];
        }
        this.addForm.buttons = row.buttons || '';
      } else {
        this.addForm.type = this.searchForm.type || "B2B";
        this.addForm.parentId = 0;
      }
      this.addDrawer = true;
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      for (const key in this.addForm) {
        this.addForm[key] = "";
      }
      this.addDrawer = false;
    },
    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            Idico: encodeURIComponent(this.addForm.icon),
            id: this.addForm.id,
            power: this.addForm.name,
            action: this.addForm.path,
            father: this.addForm.parentId,
            sort: this.addForm.sort,
            source: this.addForm.type,
            buttons: this.addForm.buttons,
          };
          let url = "";
          if (this.addForm.id) {
            url = "Role/PowerEdit_Action";
          } else {
            url = "Role/PowerAdd_Action";
          }
          this.$request({
            url: url,
            method: "post",
            data: data,
          })
            .then((res) => {
              if (res.Code) {
                //提示新增功能成功,关闭dialog,刷新数据
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.clearForm();
                this.getTableData();
              } else {
                this.$message({
                  message: this.Msg,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
    /**修改模块状态 */
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let type = "info";
      if (status == 0) {
        msg = "确定禁用吗?";
        type = "warning";
      } else if (status == 1) {
        msg = "确定启用吗?";
        type = "success";
      } else if (status == 2) {
        msg = "确定删除吗?";
        type = "error";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          this.$request({
            url: "Role/UpdateMethod",
            method: "post",
            data: {
              id: row.id,
              status: status,
              fatherId: row.parentId,
            },
          })
            .then((res) => {
              if (res.Code) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.Msg,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },

    /**为表格加上唯一标识，提高渲染性能 */
    getRowKeys(row) {
      return row.id; // 每条数据的唯一识别值
    },
  },
};
</script>

<style scoped>
.pathMan {
  width: 100%;
  height: 100%;
}
</style>